import * as firebase from 'firebase/app'
import 'firebase/database'

firebase.initializeApp({
  apiKey: 'AIzaSyCJq-ZYkp34R3qPx8YlNpnG6GGdl0fJx04',
  authDomain: 'nunu-5160f.firebaseapp.com',
  databaseURL: 'https://nunu-5160f.firebaseio.com/',
})

export const db = firebase.database()
